import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import categoryReducer from "./slices/category";
import franchiseThemePageReducer from "./slices/franchiseThemePage";
import statReducer from "./slices/stats";
import desiginationReducer from "./slices/desigination";
import venueUserReducer from "./slices/venueUser";
import franchiseUserReducer from "./slices/franchiseUser";
import venueReducer from "./slices/venue";
import customer from "./slices/customer";
import orderSlice from "./slices/orderSlice";
import customerReservationSlice from "./slices/customerReservationSlice";
import itemReducer from "./slices/item";
import catalogCategoryReducer from "./slices/catalogCategory";
import catalogProductReducer from "./slices/catalogProduct";
import catalogChoiceGroupReducer from "./slices/catalogChoiceGroup";
import choiceGroupReducer from "./slices/choiceGroup";
import bomReducer from "./slices/bom";
import themeSlice from "./slices/themeSlice";
import cardSlice from "./slices/cardSlice";
import accountingReducer from "./slices/accounting";
import franchiseVenueReducer from "./slices/franchiseVenue";
import franchiseWarehouseReducer from "./slices/franchiseWarehouse";
import subscriptionInvoiceReducer from "./slices/subscriptionInvoice";
import franchisePromotionReducer from "./slices/franchisePromotion";
import promotionsReducer from "./slices/promotions";

export const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const cateogoryPersistConfig = {
  key: "category",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const franchiseThemePagePersistConfig = {
  key: "franchiseThemePage",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const statPersistConfig = {
  key: "stat",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const desiginationPersistConfig = {
  key: "desigination",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const venueUserPersistConfig = {
  key: "venueUser",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const venuePersistConfig = {
  key: "venue",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const choiceGroupPersistConfig = {
  key: "choiceGroup",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};
export const catalogChoiceGroupPersistConfig = {
  key: "catalogChoiceGroup",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};
export const bomPersistConfig = {
  key: "bom",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};
export const themePersistConfig = {
  key: "themeSlice",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};
const cartPersistConfig = {
  key: "cardSlice",
  storage,
  keyPrefix: "redux-",
  whitelist: ["isPickUp", "isDineIn"],
};

const rootReducer = combineReducers({
  category: persistReducer(cateogoryPersistConfig, categoryReducer),
  franchiseThemePage: persistReducer(franchiseThemePagePersistConfig, franchiseThemePageReducer),
  stat: persistReducer(statPersistConfig, statReducer),
  desigination: persistReducer(desiginationPersistConfig, desiginationReducer),
  franchiseUser: franchiseUserReducer,
  venueUser: persistReducer(venueUserPersistConfig, venueUserReducer),
  venue: persistReducer(venuePersistConfig, venueReducer),
  customer: customer,
  orderSlice: orderSlice,
  customerReservationSlice: customerReservationSlice,
  item: itemReducer,
  catalogCategory: catalogCategoryReducer,
  catalogProduct: catalogProductReducer,
  catalogChoiceGroup: persistReducer(catalogChoiceGroupPersistConfig, catalogChoiceGroupReducer),
  choiceGroup: persistReducer(choiceGroupPersistConfig, choiceGroupReducer),
  bom: persistReducer(bomPersistConfig, bomReducer),
  themeSlice: persistReducer(themePersistConfig,themeSlice),
  cardSlice: persistReducer(cartPersistConfig,cardSlice),
  accounting: accountingReducer,
  franchiseVenue: franchiseVenueReducer,
  franchiseWarehouse: franchiseWarehouseReducer,
  subscriptionInvoice: subscriptionInvoiceReducer,
  franchisePromotion: franchisePromotionReducer,
  promotions: promotionsReducer,
});

export default rootReducer;
